"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    height: 80px;
    position: relative;
    padding: 1em 1.5em 1em 92px;
    background: #4d005b;
    @media screen and ${constants_1.Device.tablet} {
        font-size: 12px;
    }

    &.giftcard-banner .giftcard-callout {
        h2 {
            text-align: left;
            color: white;
            margin-top: 10px;
            @media screen and ${constants_1.Device.laptopM} {
                font-size: 1.5em;
            }
            @media screen and ${constants_1.Device.laptop} {
                font-size: 1.3em;
            }
            @media screen and ${constants_1.Device.tablet} {
                margin-bottom: 8px;
                margin-top: 0;
                font-size: 1.2em;
            }
        }
    }

    button {
        float: right;
        margin-top: 0;
        text-transform: uppercase;
        padding: 12px 8% 8px;
        font-size: 1.5em;
        outline: none;
        border: none;
    }

    .redeem-btn .btn.btn-primary {
        @media screen and ${constants_1.Device.tablet} {
            float: none;
            font-size: 1.25em;
        }
        @media screen and ${constants_1.Device.mobileL} {
            float: none;
            font-size: 1em;
        }
    }

    .giftcard-image {
        position: absolute;
        top: 15%;
        left: 10px;
        height: 70%;
        z-index: 10;
    }
`;
//# sourceMappingURL=GiftcardBannerStyled.js.map